export default function() {
  var size = 0;
  this.visit(function(node) {
    if (!node.length) do ++size; while (node = node.next)
  });
  return size;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-quadtree/src/size.js
// module id = 1005
// module chunks = 0